import { stores as Stores } from '@iyunbao/utils';
import { Toast } from 'zarm';
import fetchAPI from './fetchAPI';

class Model {
  constructor(name: string, option: any, expire?: any, params?: any) {
    const notCached = !!~window.location.search.indexOf('notcached');
    this.expire = (notCached ? 0 : expire) || 0;
    this.option = option;
    this.params = params;
    this.store = new Stores(name, expire, {
      prefix: 'CRM_',
    });
  }

  // 失效时间
  expire: number = 0;

  option: any = {};

  store: any;

  params: any;

  // 删除数据
  deleteStore() {
    if (this.expire !== 0 && this.store.has(this.params)) {
      this.store.delete();
    }
  }

  // 执行
  execute(callback: (result: any) => void, errorCallback?: (result: any) => void) {
    if (this.expire !== 0 && this.store.has(this.params)) {
      callback && callback(this.store.get(this.params));
    } else {
      fetchAPI
        .fetchResult(this.option)
        .then((result: any) => {
          this.store.set(result, this.params);
          callback && callback(result);
        }, (error: string) => {
          if (error && typeof error === 'string') {
            Toast.show({
              content: error,
              mask: true,
            });
          }
          errorCallback && errorCallback(error);
        });
    }
  }
}

/**
 * Model 用于数据获取 和 数据缓存
 * @param {string} name   名字
 * @param {object} option 接口参数
 * @param {string} expire 缓存时间
 * @param {object} params store参数
 */
export function createModel(name: string, option: any = {}, expire?: number, params?: any) {
  return new Model(name, option, expire, params);
}

export default Model;
